"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

var _Timer = _interopRequireDefault(require("./Timer"));

var _useLocalize = _interopRequireDefault(require("../hooks/useLocalize"));

var _useLocalizeDate = _interopRequireDefault(require("../hooks/useLocalizeDate"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // This function calculates the next absolute time that the timer should be fired based on the origin (original time received), interval, and current time.
// If the origin is t=260, and we are currently at t=1000, nextTimer must return t=60260.
// If the origin is t=260, and we are currently at t=60260 (exact landing), we must return t=120260, not t=60260.
// This is for fixing bug #2103: https://github.com/microsoft/BotFramework-WebChat/issues/2103.


var TIMER_INTERVAL = 60000;

function nextTimer(origin) {
  var time = new Date(origin).getTime();
  var now = Date.now();
  return time > now ? time : now + TIMER_INTERVAL - (now - time) % TIMER_INTERVAL;
}

var RelativeTime = function RelativeTime(_ref) {
  var value = _ref.value;
  var localizedAbsoluteTime = (0, _useLocalize.default)('SentAt') + (0, _useLocalizeDate.default)(value);
  var text = (0, _useLocalize.default)('X minutes ago', value);

  var _useState = (0, _react.useState)(nextTimer(value)),
      _useState2 = _slicedToArray(_useState, 2),
      timer = _useState2[0],
      setTimer = _useState2[1];

  var handleInterval = (0, _react.useCallback)(function () {
    setTimer(nextTimer(value));
  }, [setTimer, value]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
    text: localizedAbsoluteTime
  }), _react.default.createElement("span", {
    "aria-hidden": true
  }, text), _react.default.createElement(_Timer.default, {
    at: timer,
    onInterval: handleInterval
  }));
};

RelativeTime.propTypes = {
  value: _propTypes.default.string.isRequired
};
var _default = RelativeTime;
exports.default = _default;